import { Button } from "@repo/core/components/core/Button";
import { VStack } from "@gluestack-ui/themed";
import { ConfirmStoreModalFooterProps } from "./types";

export const ConfirmStoreModalFooter = ({
  onSelectConfirm,
  onSelectCancel
}: ConfirmStoreModalFooterProps) => {
  return (
    <VStack gap="$3" width="$full" alignItems="center" pb="$6">
      <Button
        width="$full"
        text="Sim, continuar nessa loja"
        onPress={onSelectConfirm}
      />
      <Button
        size="lg"
        width="$full"
        variant="outline"
        action="default"
        onPress={onSelectCancel}
        text="Não, mudar de loja"
      />
    </VStack>
  );
};
